import script from "./TicketVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketVideo.vue?vue&type=script&setup=true&lang=js"

import "./TicketVideo.vue?vue&type=style&index=0&id=61b626ac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b626ac"]])

export default __exports__